import { render, staticRenderFns } from "./LeftTabs.vue?vue&type=template&id=2157690e&scoped=true"
import script from "./LeftTabs.vue?vue&type=script&lang=js"
export * from "./LeftTabs.vue?vue&type=script&lang=js"
import style0 from "./LeftTabs.vue?vue&type=style&index=0&id=2157690e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157690e",
  null
  
)

export default component.exports